// extracted by mini-css-extract-plugin
module.exports = {"Breadcumb":"Breadcumb_Breadcumb__1CaYj","Tabs":"Breadcumb_Tabs__3HFnz","FirstTab":"Breadcumb_FirstTab__1_kfN"};